<template>
	<section class="tool-submission-details-settings-root card p-3 mt-3">
		<h2 class="form-subtitle mb-2">Submission details</h2>
		<p class="text-muted mb-3">New clients enter their name and email when they submit. Choose any additional details to collect.</p>
		<CollectInfoSettingsView v-model="details" @change="commit"/>
		<FormTextRow v-model="thankYouMessage" title="Thank you message" :is-vertical="true" :multiline="true" :min-rows="3" class="mt-4" @change="commit"/>
	</section>
</template>

<script>
import AdditionalInfoItem from "@shared/Profile/AdditionalInfoItem.js";
import CollectInfoSettingsView from "@/core/components/Picker/ClientPickerView/CollectInfoSettingsView.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import {DEFAULT_TOOL_THANK_YOU_MESSAGE} from "@shared/SharedConstants.js";

export default {
	name: "ToolSubmissionDetailsSettings",
	components: {CollectInfoSettingsView, FormTextRow},
	props: {toolInstance: {type: Object, required: true}},
	emits: ["update:toolInstance", "change"],
	data() {return {
		details: new AdditionalInfoItem(this.toolInstance.submissionDetails || {}),
		thankYouMessage: this.toolInstance.thankYouMessage || DEFAULT_TOOL_THANK_YOU_MESSAGE,
	}},
	watch: {
		'toolInstance.submissionDetails': {deep: true, handler(value) {
			if (JSON.stringify(value || {}) !== JSON.stringify(this.details)) this.details = new AdditionalInfoItem(value || {})
		}},
		'toolInstance.thankYouMessage': function(value) {
			if (value !== this.thankYouMessage) this.thankYouMessage = value || DEFAULT_TOOL_THANK_YOU_MESSAGE
		},
	},
	methods: {
		commit() {
			this.$emit("update:toolInstance", {...this.toolInstance, submissionDetails: new AdditionalInfoItem(this.details), thankYouMessage: this.thankYouMessage.trim() || DEFAULT_TOOL_THANK_YOU_MESSAGE})
			this.$emit("change")
		},
	},
}
</script>
